// excludes backslash as well as the usual specials; dropping it silently widened what
// the Swoogo registration check accepts
const CHARS = '[^<>()[\\]\\\\.,;:\\s@"]';

export const EMAIL_REGEX = new RegExp(`^((${CHARS}+(\\.${CHARS}+)*)|(".+"))@((${CHARS}+\\.)+${CHARS}{2,})$`, 'i');

export const validateEmail = email => EMAIL_REGEX.test(email);
